module.exports = __webpack_public_path__ + "static/media/ido-sol.4e0778a9.svg";